<div class="editor-page">
  <div class="container-xxl editor">
    <header class="editor-head">
      <div class="editor-title-row">
        <button class="editor-back" type="button" aria-label="Indietro" (click)="goBack()">
          <i class="bi bi-arrow-left" aria-hidden="true"></i>
          <span class="back-label">Indietro</span>
        </button>
        <div class="editor-banner">
          <img src="assets/img/contactBar.png" alt="">
          <h1>Modifica scheda</h1>
        </div>
      </div>
      <div class="editor-toolbar">
        <p class="editor-note">I campi con <sup>*</sup> sono obbligatori.</p>
        <button class="editor-secondary" type="button" [disabled]="articleForm.dirty" (click)="goToArticle()">
          Visualizza scheda
        </button>
      </div>
    </header>

    <div class="editor-layout">
      <div class="editor-form">
      <form class="editor-fields" [formGroup]="articleForm">
        <section class="editor-panel">
          <h2>Identificativo</h2>
          <div class="field-grid field-grid-2">
            <div class="field-block">
              <label for="code">Codice articolo</label>
              <input id="code" class="field" type="text" placeholder="Codice univoco" formControlName="code">
            </div>
            <div class="field-block">
              <label for="progressive">Progressivo</label>
              <input id="progressive" class="field" type="text" placeholder="Progressivo" formControlName="progressive">
            </div>
          </div>
        </section>

        <section class="editor-panel">
          <h2>Classificazione</h2>
          <div class="field-grid field-grid-2">
            <div class="field-block">
              <label for="category">Categoria<sup>*</sup></label>
              <select id="category" class="field" formControlName="category">
                <option [ngValue]="null" disabled>Seleziona una categoria</option>
                @for (item of categoryOptions; track item.id) {
                  <option [ngValue]="item.id">{{ item.title }}</option>
                }
              </select>
            </div>
            <div class="field-block">
              <label for="subCategory">Sottocategoria</label>
              <select id="subCategory" class="field" formControlName="subCategory">
                <option [ngValue]="null">Seleziona una sottocategoria</option>
                @for (option of subcategoryOptions; track option.id) {
                  <option [ngValue]="option.id">{{ option.title }}</option>
                }
              </select>
            </div>
          </div>
        </section>

        <section class="editor-panel">
          <h2>Contenuto</h2>
          <div class="field-stack">
            <div class="field-block">
              <label for="title">Titolo<sup>*</sup></label>
              <input id="title" class="field" type="text" placeholder="Titolo della scheda" formControlName="title">
            </div>
            <div class="field-block">
              <label for="description">Descrizione</label>
              <textarea id="description" class="field field-area" rows="4" placeholder="Descrizione della scheda"
                formControlName="description"></textarea>
            </div>
          </div>
        </section>

        <section class="editor-panel">
          <h2>Data e visibilità</h2>
          <div class="field-grid field-grid-2">
            <div class="field-block">
              <span class="field-label" id="date-format-label">Data</span>
              <div class="format-switch" role="group" aria-labelledby="date-format-label">
                <input type="radio" name="yearFormat" id="date" (click)="changeFormat('date')" [checked]="yearFormat === 'date'">
                <label for="date">Data</label>

                <input type="radio" name="yearFormat" id="year" (click)="changeFormat('year')" [checked]="yearFormat === 'year'">
                <label for="year">Anno</label>

                <input type="radio" name="yearFormat" id="period" (click)="changeFormat('period')" [checked]="yearFormat === 'period'">
                <label for="period">Periodo</label>
              </div>

              @if (yearFormat == 'date') {
                <input class="field" type="date" aria-label="Data" formControlName="date">
              }
              @if (yearFormat == 'year') {
                <input id="year-value" class="field" type="text" placeholder="Anno singolo" formControlName="year"
                  (input)="isCorrectYearLogic()"
                  [class.is-invalid]="articleForm.get('year')?.invalid && (articleForm.get('year')?.dirty || articleForm.get('year')?.touched)">
              }
              @if (yearFormat == 'period') {
                <div class="period-fields">
                  <input id="yearFrom" class="field" type="text" placeholder="Dal" formControlName="yearFrom"
                    (input)="isCorrectPeriodLogic()" [class.is-invalid]="articleForm.get('yearFrom')?.invalid">
                  <input id="yearTo" class="field" type="text" placeholder="Al" formControlName="yearTo"
                    (input)="isCorrectPeriodLogic()" [class.is-invalid]="articleForm.get('yearTo')?.invalid">
                </div>
              }
            </div>

            <div class="field-block">
              <span class="field-label">Visibilità</span>
              <div class="visibility-controls">
                <label class="switch" for="public">
                  <input id="public" type="checkbox" role="switch" formControlName="public" (change)="enableDisablePublication()">
                  <span class="switch-track" aria-hidden="true"></span>
                  <span>Pubblico</span>
                </label>
                @if (articleForm.get('public')?.value == 1) {
                  <input id="public_year" class="field" type="text" placeholder="Anno pubblicazione" formControlName="public_year"
                    aria-label="Anno pubblicazione"
                    (input)="isCorrectPublicYear()"
                    [class.is-invalid]="articleForm.get('public_year')?.invalid && (articleForm.get('public_year')?.dirty || articleForm.get('public_year')?.touched)">
                }
              </div>
            </div>
          </div>
        </section>

        <section class="editor-panel">
          <h2>Luogo</h2>
          <div class="field-stack">
            <div class="field-block">
              <label for="city">Città</label>
              <input id="city" class="field" type="text" placeholder="Città" matInput [matAutocomplete]="city"
                formControlName="city"
                [class.is-invalid]="articleForm.get('city')?.invalid && (articleForm.get('city')?.dirty || articleForm.get('city')?.touched)">
              <mat-autocomplete #city="matAutocomplete" class="editor-city-panel" panelClass="editor-city-panel"
                [displayWith]="displayCityName">
                @for (option of filteredCity$ | async; track option.id) {
                  <mat-option [value]="option">{{ option.name }}</mat-option>
                }
              </mat-autocomplete>
            </div>
            <div class="field-block">
              <label for="pointOfInterest">Luogo d'interesse</label>
              <input id="pointOfInterest" class="field" type="text" placeholder="Luogo" formControlName="pointOfInterest">
            </div>
            <div class="field-block">
              <label for="location">Luogo di conservazione<sup>*</sup></label>
              <input id="location" class="field" type="text" placeholder="Luogo" formControlName="location">
            </div>
          </div>

          <div class="place-grid">
            <div class="field-block">
              <label for="floor">Piano<sup>*</sup></label>
              <input id="floor" class="field" type="text" placeholder="Piano edificio" formControlName="floor">
            </div>
            <div class="field-block">
              <label for="room">Stanza<sup>*</sup></label>
              <input id="room" class="field" type="text" formControlName="room">
            </div>
            <div class="field-block">
              <label for="rack">Scaffale / armadio<sup>*</sup></label>
              <input id="rack" class="field" type="text" formControlName="rack">
            </div>
            <div class="field-block">
              <label for="shelf">Ripiano<sup>*</sup></label>
              <input id="shelf" class="field" type="text" formControlName="shelf">
            </div>
            <div class="field-block">
              <label for="case">Contenitore<sup>*</sup></label>
              <input id="case" class="field" type="text" formControlName="case">
            </div>
          </div>
        </section>

      </form>

        <section class="editor-panel" [formGroup]="externalLinkForm">
          <h2>Link esterni</h2>
          <label class="check" for="isLink">
            <input id="isLink" type="checkbox" formControlName="isLink" (click)="stampa()">
            <span>Link esterni</span>
          </label>

          @if (externalLinkForm.get('isLink')?.value == true) {
            <div class="link-list" formArrayName="links">
              @for (link of links.controls; track $index; let i = $index) {
                <div class="field-block" [formGroupName]="i">
                  <label [for]="'url-' + i">Link</label>
                  <div class="link-input">
                    <input class="field" type="text" [id]="'url-' + i" formControlName="url">
                    @if (i > 0) {
                      <button class="link-remove" type="button" (click)="deleteLink(i)" [attr.aria-label]="'Rimuovi link ' + (i + 1)">
                        <i class="bi bi-trash" aria-hidden="true"></i>
                      </button>
                    }
                  </div>
                </div>
              }
              <button class="editor-secondary" type="button" (click)="addEmptyLink()">
                <i class="bi bi-plus" aria-hidden="true"></i>
                Aggiungi link
              </button>
            </div>
          }
        </section>

        <div class="editor-actions">
          @if (!articleForm.valid) {
            <p class="editor-hint">Compila correttamente tutti i campi per abilitare il salvataggio.</p>
          }
          <button class="editor-save" type="button" [disabled]="!articleForm.valid" (click)="saveArticle()">
            Salva scheda
          </button>
        </div>
      </div>

      <aside class="files-panel" aria-label="File della scheda">
        <h2>File</h2>
        @if (files.length > 0) {
          @for (file of files; track file.id) {
            @if (file.id === currentImg) {
              <div class="gallery-stage">
                @if (file.ext != 'pdf' && file.ext != 'mp4' && file.ext != 'youtube') {
                  <img [src]="urlServerLaraApiMultimedia + file.src" [alt]="file.title || ''">
                }
                @if (file.ext == 'pdf') {
                  <img class="is-document" [src]="thumbnails[file.src] || 'assets/img/pdfThumbnail.png'" [alt]="file.title || 'Documento PDF'">
                }
                @if (file.ext == 'mp4') {
                  <video class="gallery-video" controls>
                    <source [src]="urlServerLaraApiMultimedia + file.src" type="video/mp4">
                  </video>
                }
                @if (file.ext == 'youtube') {
                  <iframe class="gallery-video" [src]="file.sanitized_url" [title]="file.title || 'Video'"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen>
                  </iframe>
                }

                @if (files.length > 1) {
                  <button class="gallery-nav gallery-nav-prev" type="button" (click)="stepFile(-1)" aria-label="File precedente">
                    <i class="bi bi-chevron-left" aria-hidden="true"></i>
                  </button>
                  <button class="gallery-nav gallery-nav-next" type="button" (click)="stepFile(1)" aria-label="File successivo">
                    <i class="bi bi-chevron-right" aria-hidden="true"></i>
                  </button>
                }
              </div>
            }
          }

          <div #fileList class="file-list">
            @for (file of files; track file.id) {
              <div #fileItem class="file-item">
                <button class="gallery-thumb" type="button" [class.is-active]="file.id === currentImg"
                  [attr.aria-label]="file.title || 'File'" (click)="visualizeImg(file.id)">
                  @if (file.ext != 'pdf' && file.ext != 'mp4' && file.ext != 'youtube') {
                    <img [src]="urlServerLaraApiMultimedia + file.src" [alt]="file.title || ''">
                  }
                  @if (file.ext == 'pdf') {
                    <img class="is-document" [src]="thumbnails[file.src] || 'assets/img/pdfThumbnail.png'" [alt]="file.title || 'PDF'">
                  }
                  @if (file.ext == 'mp4' || file.ext == 'youtube') {
                    <img [src]="urlServerLaraApiMultimedia + file.src_placeholder" [alt]="file.title || 'Video'">
                  }
                </button>
                <div class="file-actions">
                  <button type="button" aria-label="Elimina file" (click)="deleteImg(file.id)">
                    <i class="bi bi-trash" aria-hidden="true"></i>
                  </button>
                  @if (file.cover === 0) {
                    <button class="file-cover" type="button" aria-label="Imposta come copertina" (click)="changeCover(file.id)">
                      <i class="bi bi-star" aria-hidden="true"></i>
                    </button>
                  } @else {
                    <span class="is-cover" aria-label="Copertina">
                      <i class="bi bi-star-fill" aria-hidden="true"></i>
                    </span>
                  }
                </div>
              </div>
            }
          </div>
        } @else {
          <p class="gallery-empty">Nessun file associato a questa scheda.</p>
        }

        <label class="editor-secondary files-upload" for="fileUpload">
          <i class="bi bi-upload" aria-hidden="true"></i>
          Carica file
          <input id="fileUpload" type="file" (change)="onFileSelected($event)" accept="*" multiple>
        </label>
        @if (errorMessage != '') {
          <p class="files-error">{{ errorMessage }}</p>
        }
      </aside>
    </div>
  </div>
</div>
